(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["banner"] && !Shopify.designMode) return;
  try {
    const { ThemeEvents } = window.POV;
  const SELECTORS = {
    CART_BANNERS: '[data-cart-items] [data-banner], [action="/cart/add"] [data-banner]',
    BANNER_CONTENT: '[data-banner-content]',
  };

  document.addEventListener(ThemeEvents.cartErrored, handleCartErrored);
  document.addEventListener(ThemeEvents.cartUpdated, hideBanners);
  document.addEventListener(ThemeEvents.cartFormSubmitted, hideBanners);
  document.addEventListener(ThemeEvents.optionSelected, hideBanners);

  function hideBanners() {
    const banners = Array.from(document.querySelectorAll(SELECTORS.CART_BANNERS));
    banners.forEach(banner => {
      banner.classList.add('hidden');
    });
  }

  function handleCartErrored(event) {
    const { type, errorMessage, lineId } = event.detail;
    const banners = Array.from(document.querySelectorAll(SELECTORS.CART_BANNERS));
    banners.forEach(banner => {
      banner.classList.add('hidden');
      if (banner.getAttribute('data-banner') === lineId) {
        banner.classList.remove('hidden');
        banner.querySelector(SELECTORS.BANNER_CONTENT).innerHTML = errorMessage;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-summary"] && !Shopify.designMode) return;
  try {
    'use strict';

  const { ThemeEvents } = window.POV;

  const SELECTORS = {
    SUMMARY_CONTAINER: '[data-cart-summary]',
    SUMMARY_CHECKOUT_BUTTON: '[data-checkout-button]',
  };

  document.addEventListener(ThemeEvents.cartQuantityUpdated, handleCartQuantityUpdated);
  document.addEventListener(ThemeEvents.cartErrored, handleCartErrored);
  document.addEventListener(ThemeEvents.cartUpdated, handleCartUpdated);

  function handleCartErrored(event) {
    const checkoutButton = document.querySelector(SELECTORS.SUMMARY_CHECKOUT_BUTTON);
    checkoutButton.removeAttribute('disabled');
  }

  function handleCartQuantityUpdated(event) {
    const checkoutButton = document.querySelector(SELECTORS.SUMMARY_CHECKOUT_BUTTON);
    checkoutButton.setAttribute('disabled', true);
  }

  function handleCartUpdated(event) {
    const checkoutButtons = document.querySelectorAll(SELECTORS.SUMMARY_CHECKOUT_BUTTON);
    checkoutButtons.forEach(button => {
      if (event.detail.itemCount > 0) {
        button.removeAttribute('disabled');
      } else {
        button.setAttribute('disabled', true);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["countdown"] && !Shopify.designMode) return;
  try {
    (function Countdown() {
    'use strict';

    const SELECTORS = {
      ROOT: '[data-countdown]',
      HOURS: '[data-countdown-hours]',
      MINUTES: '[data-countdown-minutes]',
      SECONDS: '[data-countdown-seconds]',
      STATUS: '[data-countdown-status]',
      HIDE_ON_END: '[data-countdown-hide-on-end]',
    };

    const timers = Array.from(document.querySelectorAll(SELECTORS.ROOT)).map(init).filter(Boolean);
    if (!timers.length) return;

    // Declared before the first tick so an already-ended countdown can call clearInterval without hitting the TDZ
    let interval;
    tick();
    if (!allEnded()) interval = setInterval(tick, 1000);

    function init(root) {
      const ends = Number(root.getAttribute('data-countdown-ends')) * 1000;
      if (!ends) return null;

      let i18n = {};
      try {
        i18n = JSON.parse(root.getAttribute('data-countdown-i18n') || '{}');
      } catch (error) {
        i18n = {};
      }

      return {
        root: root,
        ends: ends,
        i18n: i18n,
        hours: root.querySelector(SELECTORS.HOURS),
        minutes: root.querySelector(SELECTORS.MINUTES),
        seconds: root.querySelector(SELECTORS.SECONDS),
        status: root.querySelector(SELECTORS.STATUS),
        lastMinute: null,
        ended: false,
      };
    }

    function tick() {
      const now = Date.now();

      timers.forEach(function (timer) {
        if (timer.ended) return;
        const remaining = Math.max(0, Math.floor((timer.ends - now) / 1000));
        render(timer, remaining);
        if (remaining === 0) end(timer);
      });

      if (allEnded()) clearInterval(interval);
    }

    function allEnded() {
      return timers.every(function (timer) { return timer.ended; });
    }

    function render(timer, remaining) {
      const hours = Math.floor(remaining / 3600);
      const minutes = Math.floor((remaining % 3600) / 60);
      const seconds = remaining % 60;

      timer.hours.textContent = pad(hours);
      timer.minutes.textContent = pad(minutes);
      timer.seconds.textContent = pad(seconds);

      // The live region only changes once a minute so screen readers are not flooded
      if (minutes !== timer.lastMinute && timer.status) {
        timer.lastMinute = minutes;
        timer.status.textContent = statusText(timer.i18n, hours, minutes);
      }
    }

    function end(timer) {
      timer.ended = true;
      timer.root.setAttribute('data-countdown-ended', '');

      // closest() includes the row itself, which carries the attribute; a wrapping block can carry it instead to hide more
      const wrapper = timer.root.closest(SELECTORS.HIDE_ON_END);
      if (wrapper) wrapper.setAttribute('hidden', '');

      timer.root.dispatchEvent(new CustomEvent('countdown:ended', { bubbles: true }));
    }

    function pad(n) {
      return n < 10 ? '0' + n : String(n);
    }

    function statusText(i18n, hours, minutes) {
      const hoursLabel = hours + ' ' + (hours === 1 ? i18n.hour : i18n.hours);
      const minutesLabel = minutes + ' ' + (minutes === 1 ? i18n.minute : i18n.minutes);
      return String(i18n.status || '').replace('[[hours]]', hoursLabel).replace('[[minutes]]', minutesLabel);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card-swatches"] && !Shopify.designMode) return;
  try {
    'use strict';

const { nodeList, head, last } = window.POV.utils;

var swatchImages = {};
var triggers = nodeList('[data-swatch-color]');

triggers.forEach(function(node){
  node.addEventListener('click', init);
});

function init(evt){
  evt.stopPropagation();
  evt.preventDefault();

  var trigger = this;
  var attrList = trigger.getAttribute('data-swatch-color').split(',');
  var handle = last(attrList);
  var color = head(attrList);
  var picture = trigger.closest('[data-product-item]').querySelector('.product-card-hover');

  if (!swatchImages[handle]) {
    fetch('/products/' + handle + '?view=color-image').then(function(response){
      return response.json();
    }).then(function(data) {
      swatchImages[handle] = data;
      setImage(handle, color, picture);
    });
  } else {
    setImage(handle, color, picture);
  }
}

function setImage(handle, color, picture) {
  const div = document.createElement('div');
  
  div.innerHTML = swatchImages[handle][color];
  const newImg = div.querySelector('img');
  picture.src = newImg.src;
  picture.srcset = newImg.srcset;
}

// Reinit on filter DOM update
window.addEventListener('filter:change', function reInit(){
  var triggers = nodeList('[data-swatch-color]');
  
  triggers.forEach(function(node){
    node.addEventListener('click', init);
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["slider"] && !Shopify.designMode) return;
  try {
    (function Slider(namespace){
  'use strict';

  const { ThemeEvents } = window.POV;
  const { SliderChangedEvent, SliderChangingEvent } = window.POV.EventsConstructors;
  const { compose, partial, head, last, nodeList, debounce, emit } = window.POV.utils;

  var initSequence = compose(publicAPI, setControlsDisabled, setControlsVisibility, setEvents, collate);
  var reInitSequence = compose(setControlsDisabled, setControlsVisibility);
  var triggerClickSequence = compose(setScroll, getScrollOffset, setDirection);

  try {
    namespace.Slider = nodeList('[data-slider]').map(initSequence);
  } catch(error) {
    console.log(error)
  }
  
  function publicAPI(data) {
    return {
      id: data.container.id,
      elements: {
        container: data.container,
        triggerPrev: data.triggerPrev,
        triggerNext: data.triggerNext,
        track: data.track,
        items: data.items
      },
      position: partial(findCurrentPosition, data),
      itemAtPosition: partial(getItemByPosition, data),
      reinit: partial(reInitSequence, data),
      canScrollPrev: partial(canScrollPrev, data),
      canScrollNext: partial(canScrollNext, data),
      scrollToStart: partial(scrollToStart, data),
      scrollToEnd: partial(scrollToEnd, data),
      scrollToPosition: partial(scrollToPosition, data),
      revealPosition: partial(revealPosition, data)
    }
  }

  // Get all nodes needed
  function collate(node) {
    return {
      container: node,
      triggerPrev: node.querySelector('[data-slider-trigger-prev]'),
      triggerNext: node.querySelector('[data-slider-trigger-next]'),
      track: node.querySelector('[data-slider-track]'),
      get items() {
        var childrenArray = Array.prototype.slice.call(node.querySelector('[data-slider-track]').children);
        //console.log(childrenArray)
        return childrenArray.filter(function(item) {
          return item.tagName !== 'STYLE';
        })
      },
      get firstItem() {
        return head(this.items);
      },
      get lastItem() {
        return last(this.items);
      }
    }
  }

  function setEvents(data) {
    if (data.triggerPrev) data.triggerPrev.addEventListener('click', partial(triggerClickSequence, data, 'prev'));
    if (data.triggerNext) data.triggerNext.addEventListener('click', partial(triggerClickSequence, data, 'next'));

    var debounceScroll = debounce(partial(onScrollEnd, data), 66);
    data.track.addEventListener('scroll', debounceScroll);
    data.track.addEventListener('scroll', partial(onScroll, data), { passive: true });

    return data;
  }

  function setDirection(data, direction) {
    data.direction = direction; 
    return data;
  }

  function findNextItem(data) {
    var i = 0;
    var trackBox = data.track.getBoundingClientRect();
    var items = data.items;

    for (; i < items.length; i += 1) {
      var itemBox = items[i].getBoundingClientRect();

       // Item right edge is outside the scroll container
      if (Math.round(itemBox.right) > Math.round(trackBox.right)) {
        return items[i];
        break;
      }
    }
  }

  function findPrevItem(data) {
    var i = 0;
    var trackBox = data.track.getBoundingClientRect();
    var items = data.items;

    for (var i = items.length - 1; i >= 0; i--) {
      var itemBox = items[i].getBoundingClientRect();
      
      // Item left edge is outside the scroll container
      if (Math.round(itemBox.left) < Math.round(trackBox.left)) {
        return items[i];
        break;
      }
    }
  }

  function getItemByPosition(data, position) {
    return data.items.find(item => Number(item.getAttribute('data-position')) === Number(position));
  }

  function findCurrentPosition(data) {
    var i = 0;
    var trackBox = data.track.getBoundingClientRect();
    var items = data.items;

    for (; i < items.length; i += 1) {
      var itemBox = items[i].getBoundingClientRect();

       // Item right edge is outside the scroll container
      if (Math.round(trackBox.left) <= Math.round(itemBox.left)) {
        return items[i].getAttribute('data-position');
        break;
      }
    }
  }

  function getScrollOffset(data) {
    var trackBox = data.track.getBoundingClientRect();

    if (data.direction === 'next') {
      var item = findNextItem(data);
      data.offset = trackBox.left - item.getBoundingClientRect().left;
    }

    if (data.direction === 'prev') {
      var item = findPrevItem(data);
      data.offset = trackBox.right - item.getBoundingClientRect().right
    }

    return data;
  }

  // API method: scrollX
  function scrollX(data, offsetX) {
    data.offset = offsetX;
    setScroll(data);
  }

  // API method: scrollToStart
  function scrollToStart(data) {
    data.offset = data.track.scrollWidth;
    setScroll(data);
  }

  // API method: scrollToStart
  function scrollToEnd(data) {
    var firstItemLeft = head(data.items).getBoundingClientRect().left;
    var lastItemRight = last(data.items).getBoundingClientRect().right;

    data.offset = firstItemLeft - lastItemRight;
    setScroll(data);
  }

  // API method: scrollToPosition
  function scrollToPosition(data, position) {
    var trackBoxRight = data.track.getBoundingClientRect().left;
    var item = data.items.find(item => Number(item.getAttribute('data-position')) === Number(position));
    data.offset = trackBoxRight - item.getBoundingClientRect().left
    setScroll(data);
  }

  // API method: revealPosition
  // Scrolls only when the item is not fully visible, and then the minimum distance,
  // keeping one neighbour in view on the revealed side so users can see there is
  // more. Targets land on an item edge so scroll snapping does not move the track a
  // second time. Scrolls the track element only, never the page, unlike scrollIntoView.
  function revealPosition(data, position) {
    var item = getItemByPosition(data, position);
    if (!item) return;

    var track = data.track;
    var viewStart = track.scrollLeft;
    var viewEnd = viewStart + track.clientWidth;
    var itemStart = item.offsetLeft;
    var itemEnd = itemStart + item.offsetWidth;

    if (itemStart >= viewStart && itemEnd <= viewEnd) return;

    var items = data.items;
    var index = items.indexOf(item);
    var left;

    if (itemStart < viewStart) {
      var prev = items[index - 1] || item;
      left = prev.offsetLeft;
    } else {
      var next = items[index + 1] || item;
      var revealEnd = next.offsetLeft + next.offsetWidth;
      var first = items.find(function(candidate) {
        return candidate.offsetLeft >= revealEnd - track.clientWidth;
      }) || item;
      left = Math.min(first.offsetLeft, itemStart);
    }

    track.scrollTo({
      left: left,
      behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
    });
  }

  function setScroll(data) {
    var track = data.track;
    var target = clampScroll(track, track.scrollLeft - data.offset);

    // Announce where this scroll will land before it starts, so listeners (the
    // gallery thumbs) react as the move begins rather than after the animation.
    announcePosition(data, predictPosition(data, target));

    // Only flag an in-flight scroll when something will actually move; otherwise no
    // scroll event ever ends it and live tracking would stay suppressed.
    if (Math.abs(target - track.scrollLeft) < 1) return;

    data.isScrolling = true;
    track.scrollLeft += -data.offset;
  }

  function onScroll(data) {
    // A programmatic scroll already announced its destination; tracking the slides
    // it passes on the way would make listeners flicker through them.
    if (data.isScrolling) return;
    announcePosition(data, findDominantPosition(data));
  }

  // The slide a swipe is settling on: the first item at least half visible. For
  // full-width slides this flips at the midpoint of the swipe, and at rest it agrees
  // with findCurrentPosition.
  function findDominantPosition(data) {
    var scrollLeft = data.track.scrollLeft;
    var item = data.items.find(function(item) {
      return item.offsetLeft + item.offsetWidth / 2 >= scrollLeft;
    });
    return item ? item.getAttribute('data-position') : findCurrentPosition(data);
  }

  // The position findCurrentPosition will report once the track rests at scrollLeft.
  function predictPosition(data, scrollLeft) {
    var item = data.items.find(function(item) {
      return item.offsetLeft >= scrollLeft - 1;
    });
    return item ? item.getAttribute('data-position') : findCurrentPosition(data);
  }

  function clampScroll(track, value) {
    return Math.max(0, Math.min(value, track.scrollWidth - track.clientWidth));
  }

  function announcePosition(data, position) {
    if (position == null || Number(position) === Number(data.announcedPosition)) return;
    data.announcedPosition = position;

    document.dispatchEvent(new SliderChangingEvent({
      id: data.container.id,
      position: position
    }));
  }

  function setControlsDisabled(data) {
    if (!data.triggerPrev || !data.triggerNext) return data;

    canScrollPrev(data)
      ? data.triggerPrev.removeAttribute('disabled')
      : data.triggerPrev.setAttribute('disabled', true);

    canScrollNext(data)
      ? data.triggerNext.removeAttribute('disabled')
      : data.triggerNext.setAttribute('disabled', true);

    return data;
  }

  function onScrollEnd(data) {
    data.isScrolling = false;
    // Re-sync with where the track actually settled, so an interrupted programmatic
    // scroll cannot leave a stale announcement behind.
    data.announcedPosition = findCurrentPosition(data);

    setControlsDisabled(data);

    document.dispatchEvent(new SliderChangedEvent({
      id: data.container.id,
      position: findCurrentPosition(data),
      direction: data.direction // 'prev' | 'next' | undefined (swipe / programmatic)
    }));
    // Consume the direction so a later swipe or programmatic scroll isn't misattributed
    data.direction = null;

    emit('slider:change', {
      id: data.container.id,
      position: findCurrentPosition(data)
    });
  }

  function setControlsVisibility(data) {
    // Slider without items
    if (!data.items.length || !data.triggerPrev || !data.triggerNext) return data;

    if (hasScrollOverflow(data)) {
      data.triggerPrev.setAttribute('hidden', true);
      data.triggerNext.setAttribute('hidden', true);
    } else {
      data.triggerPrev.removeAttribute('hidden');
      data.triggerNext.removeAttribute('hidden');
    }

    return data;
  }

  function canScrollNext(data) {
    // Slider without items
    if (!data.items.length) return false;

    return !Boolean(Math.abs(data.lastItem.getBoundingClientRect().right - data.track.getBoundingClientRect().right) <= 1);
  }

  function canScrollPrev(data) { 
    // Slider without items
    if (!data.items.length) return false;

    return !Boolean(data.track.scrollLeft === 0);
  }

  function hasScrollOverflow(data) { 
    // Slider without items
    if (!data.items.length) return false;

    return Boolean(Math.round(data.lastItem.getBoundingClientRect().right) <= Math.round(data.track.getBoundingClientRect().right));
  }
})(window.POV);
  } catch(e) { console.error(e); }
})();

})();
